import { apiFetch } from "../../lib/api";

// Wire shape from FastAPI GET /favorites. Module-internal — UI consumers
// receive FavoriteListItem so user_id never crosses the API boundary.
type FavoriteRow = {
  user_id: string;
  station_id: string;
  created_at: string;
};

export type FavoriteListItem = {
  stationId: string;
  savedAt: string;
};

export async function listFavorites(): Promise<FavoriteListItem[]> {
  const rows = await apiFetch<FavoriteRow[]>("/favorites", { auth: true });
  return rows.map((r) => ({ stationId: r.station_id, savedAt: r.created_at }));
}
